import { useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import UserInfo from "./components/UserInfo";

export default function Account() {
    const [tab, setTab] = useState('current-fact');

    const handleChangeTab = (e, tab) => setTab(tab);
  
    return (
        <div className="content ajustes">
            <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChangeTab} aria-label="Mi Cuenta">
                    <Tab label="Mi facturación" value="current-fact" />
                </TabList>
                </Box>
                <TabPanel value="current-fact">
                    <UserInfo />
                </TabPanel>
            </TabContext>
        </div>
    )
}